import React from 'react'
import { connect } from 'react-redux'

import {
  tideStationSelector,
} from '../reducers/uiReducer'

import styles from './TideStationName.module.css'



export default connect(
  (state) => {
    return {
      station: tideStationSelector(state)
    }
  }
)(TideStationNameView)



function TideStationNameView({station}) {

  return (
    <div className={styles.container}>
      Showing data from the {station.name} tide station
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/TideStationName.js